import {Identity} from 'api/types/properties'
import {NinchatProperties} from 'api/types'

export enum ModalActionType {
    END_CONVERSATION = 'MODAL/EndConversation',
    CHANNEL_INVITE_MODAL = 'MODAL/ChannelInviteModal',
    CLOSE_CONVERSATION = 'MODAL/CloseConversation',
    CONFIRMATION_MODAL = 'MODAL/ConfirmationModal',
    EDIT_CANNED_MESSAGE = 'MODAL/EditCannedMessage',
    TRANSFER_CONVERSATION = 'MODAL/TransferConversation',
    IDENTITY = 'MODAL/Identity'
}

export interface EndConversationAction {
    meta: {show: boolean},
    payload: {channelId?: string},
    type: typeof ModalActionType.END_CONVERSATION
}

export interface ChannelInviteModal {
    meta: {show: boolean},
    payload: {accessKey?: string, noRedirectOnCancel?: boolean},
    type: typeof ModalActionType.CHANNEL_INVITE_MODAL
}

export interface CloseConversation {
    meta: {show: boolean},
    payload: {channelId?: string},
    type: typeof ModalActionType.CLOSE_CONVERSATION
}

export interface ConfirmationModal {
    meta: {show: boolean},
    payload: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onConfirm?: any
        text?: string
        title?: string
    },
    type: typeof ModalActionType.CONFIRMATION_MODAL
}

export interface EditCannedMessage {
    meta: {show: boolean},
    payload: {
        organization: boolean
        keyword?: string
        message?: string
        realmId?: NinchatProperties.RealmID
    },
    type: typeof ModalActionType.EDIT_CANNED_MESSAGE
}

export interface TransferConversationAction {
    meta: {show: boolean},
    payload: {
        queueId?: string
        channelId?: string
    },
    type: typeof ModalActionType.TRANSFER_CONVERSATION
}

export enum IdentityModalTypes {
    remove = 'remove',
    add = 'add',
    changePassword = 'changePassword'
}

export interface IdentityModalAction {
    meta: {show: boolean},
    payload: {identity?: Identity, identityType?: IdentityModalTypes},
    type: typeof ModalActionType.IDENTITY
}

export type ModalActions = EditCannedMessage |
    EndConversationAction |
    ChannelInviteModal |
    CloseConversation |
    ConfirmationModal |
    TransferConversationAction

